import { IPageTabNavLink } from "../interfaces-and-types";

export const developersNavLinks: IPageTabNavLink[] = [
  {
    name: "Developers",
    route: "",
  },
  // {
  //   name: "API Keys",
  //   route: "api-keys",
  // },
  // {
  //   name: "Webhooks",
  //   route: "webhooks",
  // },
];
